import { Axios } from './Axios';

export async function createOrganization(orgObj) {
  const url = `/org`;
  return Axios({
    url,
    method: 'post',
    data: orgObj
  });
}

export async function getOrganization(orgId) {
  const url = `/org/${orgId}`;
  return Axios({
    url,
    method: 'get'
  });
}

export async function updateOrganization(orgId, orgObj) {
  const url = `/org/${orgId}`;
  return Axios({
    url,
    method: 'patch',
    data: orgObj
  });
}
